import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'

const getDefaultState = () => {
    return {
        creatingPage: false,
        title: '',
        type: 0,
        keywords: '',
        description: '',
        thumbnail: '',
        keyBody: Math.random(),
        body: '',
        url: '',
        errors: {},
        flag: {
            type: '',
            text: ''
        }
    }
}

const normalize = (value) => String(value || '').trim()

const validate = (instance) => {
    const errors = {
        title: '',
        body: '',
        keywords: '',
        description: '',
        thumbnail: '',
        type: ''
    }

    const title = normalize(instance.state.title)
    const body = normalize(instance.state.body)
    const keywords = normalize(instance.state.keywords)
    const description = normalize(instance.state.description)
    const thumbnail = instance.state.thumbnail
    const type = Number(instance.state.type)

    if (!title) {
        errors.title = 'Required'
    }
    else if (title.length > 700) {
        errors.title = 'Too long'
    }

    if (!body) {
        errors.body = 'Required'
    }

    if (keywords.length > 200) {
        errors.keywords = 'Too long'
    }

    if (description.length > 400) {
        errors.description = 'Too long'
    }

    if (typeof thumbnail === 'string' && normalize(thumbnail).length > 1000) {
        errors.thumbnail = 'Too long'
    }

    if (type !== 0 && type !== 1) {
        errors.type = 'Invalid type'
    }

    const valid = Object.keys(errors).every((key) => errors[key].length === 0)
    instance.setState({
        ...instance.state,
        errors,
        flag: {
            type: valid ? '' : 'error',
            text: valid ? '' : 'Validation Failure'
        }
    })

    return valid
}

const mapBackendErrors = (errorPayload) => {
    if (!errorPayload) {
        return {}
    }

    if (Array.isArray(errorPayload)) {
        const mapped = {}
        errorPayload.forEach((item) => {
            if (item && item.field) {
                mapped[item.field] = item.message || 'Invalid value'
            }
        })
        return mapped
    }

    if (typeof errorPayload === 'object') {
        return errorPayload
    }

    return {}
}

const createPayload = (instance) => {
    const formData = new FormData()
    formData.append('title', normalize(instance.state.title))
    formData.append('body', instance.state.body)
    formData.append('keywords', normalize(instance.state.keywords))
    formData.append('description', normalize(instance.state.description))
    formData.append('type', Number(instance.state.type))

    if (instance.state.thumbnail instanceof File) {
        formData.append('thumbnail', instance.state.thumbnail)
    }

    return formData
}

const createPage = (instance) => {
    if (instance.state.creatingPage) {
        return
    }

    instance.setState({
        ...instance.state,
        creatingPage: true,
        flag: {
            type: '',
            text: ''
        }
    })

    axios({
        method: 'post',
        url: API_ENDPOINT + '/api/content/page/create',
        headers: {
            Authorization: store.getState().auth.authorizationToken
        },
        data: createPayload(instance)
    }).then((response) => handleCreateResponse(instance, response))
    .catch((error) => {
        instance.setState({
            ...instance.state,
            creatingPage: false,
            flag: {
                type: 'error',
                text: 'Failed to create page. Please retry.'
            }
        })
        alert(error)
    })
}

const handleCreateResponse = (instance, response) => {
    if (response.status === 200 && response.data.status === 200) {
        const page = (response.data.data && (response.data.data.page || response.data.data.item)) || null
        instance.setState({
            ...getDefaultState(),
            url: page && page.url ? page.url : '',
            flag: {
                type: 'success',
                text: 'Page created successfully.'
            }
        })
        return
    }

    if (response.data.status === 403) {
        instance.props.history.push('/auth/login')
        return
    }

    const backendErrors = mapBackendErrors(response.data.errors || (response.data.data && response.data.data.errors))
    instance.setState({
        ...instance.state,
        creatingPage: false,
        errors: {
            ...instance.state.errors,
            ...backendErrors
        },
        flag: {
            type: 'error',
            text: response.data.message || 'Create failed.'
        }
    })
}

const CreatePageWorker = (instance) => {
    return {
        getDefaultState: () => getDefaultState(),
        isValid: () => validate(instance),
        createPage: () => createPage(instance)
    }
}

export default CreatePageWorker
